import { NearestFilter, Texture, TextureLoader, VideoTexture } from 'three'

import { Transitions } from './constants'
import fadeFragmentShader from './shaders/fadeFragmentShader.glsl'
import staticFragmentShader from './shaders/staticFragmentShader.glsl'
import tiktokFragmentShader from './shaders/tiktokFragmentShader.glsl'
import vertexShader from './shaders/vertexShader.glsl'

const textureLoader = new TextureLoader()
// Allow cross origin loading
textureLoader.crossOrigin = 'anonymous'

export const restartVideo = (video: HTMLVideoElement) => {
    video.currentTime = 0
    if (video.paused) video.play()
}

export const createScreenVideo = (src: string, onLoad?: () => void) => {
    const video = document.createElement('video')
    video.loop = true
    video.muted = true
    video.playsInline = true
    video.crossOrigin = '' // Allow videos loaded from remote domains
    const handleLoad = () => {
        if (onLoad && typeof onLoad === 'function') onLoad()
        video.removeEventListener('canplay', handleLoad)
    }
    video.addEventListener('canplay', handleLoad)
    video.src = src
    return video
}

export const createScreenTexture = (src?: string, onLoad?: () => void) => {
    let texture
    if (!src) return new Texture()
    if (src?.endsWith('.mp4')) {
        const video = createScreenVideo(src, onLoad)
        texture = new VideoTexture(video)
    } else {
        texture = textureLoader.load(src, onLoad)
    }
    texture.minFilter = NearestFilter
    texture.flipY = false
    return texture
}

export const getDynamicMaterialData = (transition: Transitions) => {
    const videoTexture = createScreenTexture()
    const nextVideoTexture = createScreenTexture()

    const screenMaterial = {
        uniforms: {
            tCurrent: { value: videoTexture },
            tNext: { value: nextVideoTexture },
            uOffset: { value: 0 },
            uBrightness: { value: 0 },
        },
        fragmentShader:
            transition === Transitions.FADE
                ? fadeFragmentShader
                : tiktokFragmentShader,
        vertexShader,
    }
    return screenMaterial
}

export const getStaticMaterialData = () => {
    const videoTexture = createScreenTexture()

    const screenMaterial = {
        uniforms: {
            tCurrent: { value: videoTexture },
            uBrightness: { value: 0 },
        },
        fragmentShader: staticFragmentShader,
        vertexShader,
    }
    return screenMaterial
}
